import type { SystemIconType } from '@fiverr-private/visuals';
import type { ArrowProps } from './types';

export const getIconSize = (buttonSize: ArrowProps['size']): SystemIconType['size'] => {
    if (buttonSize === 'lg') {
        return 'md';
    }

    return 'sm';
};
